import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../../utils/propUtils';
import VeltCommentsSidebarListItemGroupCount from './VeltCommentsSidebarListItemGroupCount/VeltCommentsSidebarListItemGroupCount';
import VeltCommentsSidebarListItemGroupArrow from './VeltCommentsSidebarListItemGroupArrow/VeltCommentsSidebarListItemGroupArrow';
import VeltCommentsSidebarListItemGroupName from './VeltCommentsSidebarListItemGroupName/VeltCommentsSidebarListItemGroupName';
var VeltCommentsSidebarListItemGroup = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-list-item-group-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarListItemGroup.Count = VeltCommentsSidebarListItemGroupCount;
VeltCommentsSidebarListItemGroup.Arrow = VeltCommentsSidebarListItemGroupArrow;
VeltCommentsSidebarListItemGroup.Name = VeltCommentsSidebarListItemGroupName;
export default VeltCommentsSidebarListItemGroup;
